import React, { useState, useRef, useEffect } from "react";
import { searchVilles } from "../../data/villes-france";
import "./LocalAutocomplete.scss";

const LocalAutocomplete = ({ setMyValue, initialValue }) => {
  const [inputValue, setInputValue] = useState(initialValue || "");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const inputRef = useRef(null);

  // Mettre à jour l'input si initialValue change
  useEffect(() => {
    if (initialValue) {
      setInputValue(initialValue);
    }
  }, [initialValue]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    
    // Notifier le parent si le champ est vidé
    if (value.trim() === '') {
      setMyValue("address", { description: '', code: '', ville: '' });
    }
    
    if (value.length >= 2) {
      const results = searchVilles(value);
      setSuggestions(results);
      setShowSuggestions(true);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  };

  const handleSelect = (item) => {
    const fullAddress = `${item.code} ${item.ville}`;
    setInputValue(fullAddress);
    setSuggestions([]);
    setShowSuggestions(false);
    setMyValue("address", { description: fullAddress, code: item.code, ville: item.ville });
  };

  const handleBlur = () => {
    setTimeout(() => {
      setShowSuggestions(false);
    }, 200);
  };

  return (
    <div className="local-autocomplete">
      <input
        ref={inputRef}
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onFocus={() => inputValue.length >= 2 && setShowSuggestions(true)}
        onBlur={handleBlur}
        placeholder="Code postal ou ville"
        className="form-control input-iconed"
        required
        id="postalCodeInput"
      />
      {showSuggestions && suggestions.length > 0 && (
        <ul className="suggestions-list">
          {suggestions.map((item, index) => (
            <li
              key={index}
              onClick={() => handleSelect(item)}
              className="suggestion-item"
            >
              <span className="location-icon">📍</span>
              <div className="suggestion-text">
                <div className="main-text">{item.ville}</div>
                <div className="secondary-text">{item.code}</div>
              </div>
            </li>
          ))}
        </ul>
      )}
      {showSuggestions && inputValue.length >= 2 && suggestions.length === 0 && (
        <ul className="suggestions-list">
          <li className="suggestion-item no-results">
            <span className="location-icon">🔍</span>
            <div className="suggestion-text">
              <div className="main-text">Aucun résultat</div>
              <div className="secondary-text">Essayez un autre code postal ou ville</div>
            </div>
          </li>
        </ul>
      )}
    </div>
  );
};

export default LocalAutocomplete;
